module.exports = __webpack_public_path__ + "static/media/ug.4b98f953.svg";